import { Box } from '@mui/system';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

const columns: GridColDef[] = [
  {
    field: 'col1',
    headerName: 'SR No',
    width: 120,
    resizable: true,
    disableColumnMenu: true,
  },
  { field: 'col2', headerName: 'Memo Date', width: 120, disableColumnMenu: true },
  { field: 'col3', headerName: 'Customer Name', width: 120, disableColumnMenu: true },
  { field: 'col4', headerName: 'CIF', width: 100, disableColumnMenu: true },
  { field: 'col5', headerName: 'Request Type', width: 120, disableColumnMenu: true },
  { field: 'col6', headerName: 'Facility Type', width: 120, disableColumnMenu: true },
  { field: 'col7', headerName: 'Facility', width: 120, disableColumnMenu: true },
  { field: 'col8', headerName: 'Facility Currency', width: 120, disableColumnMenu: true },
  { field: 'col9', headerName: 'Facility Amount', width: 120, disableColumnMenu: true },
  { field: 'col10', headerName: 'Actions', width: 120, disableColumnMenu: true },
];

const PendingCompliances = () => {
  return (
    <Box sx={{ padding: 2, height: '580px' }}>
      <DataGrid columns={columns} rows={[]} />
    </Box>
  );
};

export default PendingCompliances;
